import { ChangeDetectionStrategy, Component, forwardRef, input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { CustomFormControlComponent } from '../../../../core/abstractions/custom-form-control.component';
import { ReportScheduleDialogParameterFieldTypeEnum } from '../../../../models/enums/report-schedule-dialog-parameter-field-type.enum';
import { ReportScheduleDialogParameterFieldModel } from '../../../../models/report-schedule-dialog-parameter-field.model';

@Component({
    selector: 'sl-report-schedule-dialog-parameter-field',
    templateUrl: './report-schedule-dialog-parameter-field.component.html',
    styleUrls: ['./report-schedule-dialog-parameter-field.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => ReportScheduleDialogParameterFieldComponent)
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportScheduleDialogParameterFieldComponent extends CustomFormControlComponent {
    readonly parameterField = input.required<ReportScheduleDialogParameterFieldModel>();
    readonly required = input.required<boolean>();

    readonly ReportScheduleDialogParameterFieldTypeEnum = ReportScheduleDialogParameterFieldTypeEnum;

    override registerOnChange(fn: (value: any) => void): void {
        super.registerOnChange(fn);
        this.writeValue(this.value);
    }
}
